import React, { useState } from "react";
import SolidarityIcon from "../Assets/Icons/SolidarityIcon";
import { toast, ToastContainer } from 'react-toastify';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { LockClosedIcon, LockOpenIcon, CheckIcon } from '@heroicons/react/24/outline'
import { Navigate, useNavigate } from "react-router-dom";


const ForgotPassword = () => {
    const [isLoading, setLoading] = useState(false);
     const [username, setUsername] = useState('');
     const [newPassword, setNewPassword] = useState('');
     const [confirmPassword, setConfirmPassword] = useState('');

     const [phone, setPhone] = useState('');
     const [otp, setOtp] = useState('');
     const [otpVerified, setOtpVerified] = useState(false);
     const [pinId, setPinId] = useState('');

     const [open, setOpen] = useState(false);

     const [openNewPassPopUp, setOpenNewPassPopUp] = useState(false);
     const [resetCompleted, setResetCompleted] = useState(false);

 const navigate = useNavigate();
    

     const handleChange = (event) => {
        setUsername(event.target.value); // Update the state with the input value
      };
      const handleOTPChange = (event) => {
        setOtp(event.target.value); // Update the state with the input value
      };

      const handleNewPassChange = (event) => {
        setNewPassword(event.target.value); // Update the state with the input value
      };
      const handleConfirmPassChange = (event) => {
        setConfirmPassword(event.target.value); // Update the state with the input value
      };
    const SendOtp = async () => {
        
        const url = process.env.REACT_APP_PAYMENT_API+"Account/SendOtp";
        const data = {
          UserName: username, // Use the search string here
        };
    
        try {
          setLoading(true);
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
    
          if (!response.ok) {
            const errorDetails = await response.json();
            toast.error(errorDetails.message,{
              style:{
                background:'#ffcccc',
                color: 'black',
                fontWeight: 'bold',
              }
            });
            throw new Error("Failed to login");
          }
    
          const result = await response.json();
          var hashedPhone = result.to.slice(0, -4) + "****";
          setPhone(hashedPhone);        
          setPinId(result.pinId);
          setOpen(true);
          setLoading(false);
          //navigate('/requests');
          
        } catch (error) {
          setLoading(false);
          //toast.error(error.message);
          console.error("Error fetching payment requests:", error);
        }
      };

      const ResetPassword = async () => {
        
        const url = process.env.REACT_APP_PAYMENT_API+"Account/ResetPassword";
        const data = {
          UserName: username, // Use the search string here
          NewPassword: newPassword,
          Otp: otp,
          PinId: pinId

        };
    
        try {
          setLoading(true);
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
    
          if (!response.ok) {
            const errorDetails = await response.json();
            toast.error(errorDetails.message,{
              style:{
                background:'#ffcccc',
                color: 'black',
                fontWeight: 'bold',
              }
            });
            throw new Error("Failed to login");
          }
    
          const result = await response.json();
          //setOtpVerified(result.verified);
          setLoading(false);
          if(result.verified){
            setOpenNewPassPopUp(false);
            setResetCompleted(true);
          }
          //navigate('/requests');
          
        } catch (error) {
          setLoading(false);
          //toast.error(error.message);
          console.error("Error fetching payment requests:", error);
        }
      };

      const VerifyOTP = async () => {
        
        const url = process.env.REACT_APP_PAYMENT_API+"Account/VerifyOTP";
        const data = {
          OTP: otp, // Use the search string here
          PinId: pinId,

        };
    
        try {
          setLoading(true);
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
    
          if (!response.ok) {
            const errorDetails = await response.json();
            toast.error(errorDetails.message,{
              style:{
                background:'#ffcccc',
                color: 'black',
                fontWeight: 'bold',
              }
            });
            throw new Error("Failed to login");
          }
    
          const result = await response.json();
          
          setLoading(false);
          if(result.verified){
            setOtpVerified(true);
            setOpen(false);
            setOpenNewPassPopUp(true);
          }
          
          //navigate('/requests');
          
        } catch (error) {
          setLoading(false);
          //toast.error(error.message);
          console.error("Error fetching payment requests:", error);
        }
      };

      const Reset = async () =>{
        
        if(otpVerified){
          const passwordErrors = validatePassword(newPassword);

          if (passwordErrors.length > 0) {
            passwordErrors.forEach((error) =>
              toast.error(error, { style: { background: "#ffcccc", color: "black", fontWeight: "bold" } })
            );
            return;
          }
        
          if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match", {
              style: { background: "#ffcccc", color: "black", fontWeight: "bold" },
            });
            return;
          }
          
          await ResetPassword();
        }
        

      }

      const validatePassword = (password) => {
        const errors = [];
        if (password.length < 8) errors.push("Password must be at least 8 characters");
        if (!/[A-Z]/.test(password)) errors.push("Password must contain an uppercase letter");
        if (!/[a-z]/.test(password)) errors.push("Password must contain a lowercase letter");
        if (!/[0-9]/.test(password)) errors.push("Password must contain a number");
        if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) errors.push("Password must contain a special character");
      
        return errors;
      };

      const Back = () =>{
        
        navigate('/');
        

      }
  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-white">
        <body class="h-full">
        ```
      */}
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <SolidarityIcon />
          <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            Reset Password
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form action="#" method="POST" className="space-y-6">
            <div>
              <label
                htmlFor="username"
                className="block text-sm/6 font-medium text-gray-900"
              >
                Username
              </label>
              <div className="mt-2">
                <input
                value={username}
                onChange={handleChange}
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>

            <div>
              <button
                onClick={SendOtp}
                type="button"
                className="flex w-full justify-center rounded-md bg-sky-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-sky-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isLoading ? (
                  // Show circular loading spinner
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-sky-300 bg-sky-600"></div>
                ) : (
                  // Show text when not loading
                  "Get OTP"
                )}
              </button>
            </div>
          </form>
        </div>
        <ToastContainer />
      </div>
      
      <Dialog open={open} onClose={setOpen} className={`relative z-10`}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
                <LockClosedIcon aria-hidden="true" className="size-6 text-red-600" />
              </div>
              <div  className={`mt-3 text-center sm:mt-5 ${otpVerified ? 'hidden' : ''}`}>
                <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                  OTP Verification
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    A OTP {"(one time password)"} has been sent to {phone}
                  </p>
                </div>
                <div className="mt-2">
                <input
                value={otp}
                onChange={handleOTPChange}
                  id="otp"
                  name="number"
                  type="number"
                  required
                  autoComplete="otp"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
              </div>
              
            </div>
            <div className="mt-5 sm:mt-6">
              <button
                type="button"
                onClick={VerifyOTP}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isLoading ? (
                  // Show circular loading spinner
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-sky-300 bg-sky-600"></div>
                ) : (
                  // Show text when not loading
                  "Send Code"
                )}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>


    <Dialog open={openNewPassPopUp} onClose={setOpenNewPassPopUp} className={`relative z-10`}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                <LockOpenIcon aria-hidden="true" className="size-6 text-green-600" />
              </div>
              <div  className={`mt-3 text-center sm:mt-5`}>
                <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                  New Password
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Please enter new password and don't forget it next time otherwise we will remove your access
                  </p>
                </div>
                <div className="mt-2">
                <input
                value={newPassword}
                onChange={handleNewPassChange}
                  id="password"
                  name="password"
                  type="password"
                  required
                  autoComplete="otp"
                  placeholder="New Password"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
              <div className="mt-2">
                <input
                value={confirmPassword}
                onChange={handleConfirmPassChange}
                  id="confirmPass"
                  name="confirmPass"
                  type="password"
                  required
                  autoComplete="otp"
                  placeholder="Confirm Password"
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
              </div>
              
            </div>
            <div className="mt-5 sm:mt-6">
              <button
                type="button"
                onClick={Reset}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isLoading ? (
                  // Show circular loading spinner
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-sky-300 bg-sky-600"></div>
                ) : (
                  // Show text when not loading
                  "Reset Password"
                )}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>

    <Dialog open={resetCompleted} onClose={setResetCompleted} className={`relative z-10`}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                <CheckIcon aria-hidden="true" className="size-6 text-green-600" />
              </div>
              <div  className={`mt-3 text-center sm:mt-5`}>
                <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                  Done
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    You have successfully updated your password.
                  </p>
                </div>              
              </div>
              
            </div>
            <div className="mt-5 sm:mt-6">
              <button
                type="button"
                onClick={Back}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isLoading ? (
                  // Show circular loading spinner
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-sky-300 bg-sky-600"></div>
                ) : (
                  // Show text when not loading
                  "Login"
                )}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
    </>

    
  );
};

export default ForgotPassword;
